import { Pagination } from 'antd'
import React, { Component, useCallback, useState } from 'react'

export default function CustomPagination({
  totalLength,
  setMinValue,
  setMaxValue,
  defaultPageSize = 5,
  defaultCurrent = 1,
}) {
  const [current, setCurrent] = useState(1)

  const handleChange = useCallback((value) => {
    // setExpandedStatement(null)
    setCurrent(value)
    setMinValue((value - 1) * defaultPageSize)
    setMaxValue(value * defaultPageSize)
  }, [])

  return (
    <div className='approval-card-body-pagination' style={{textAlign: 'right'}}>
      <Pagination
        current={current}
        defaultPageSize={defaultPageSize}
        onChange={handleChange}
        defaultCurrent={defaultCurrent}
        total={totalLength}
      />
    </div>
  )
}
